import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnquireService {
  accType: any;
  private refreshListSource = new Subject<void>();

  refreshList$ = this.refreshListSource.asObservable();

  triggerRefreshList() {
    this.refreshListSource.next();
  }

  private enqDetailSource = new BehaviorSubject<any>(null);
  enqDetail$ = this.enqDetailSource.asObservable();

  setEnqDetailData(detail: any) {
    this.enqDetailSource.next(detail);
  }

  getEnqDetail() {
    return this.enqDetailSource.getValue(); // Optional fallback
  }

  updateEnqDetail(partial: Partial<any>) {
    const current = this.enqDetailSource.getValue();
    const updated = { ...current, ...partial };
    this.enqDetailSource.next(updated);
  }

  // enqDetail: any;

  // setEnqDetailData(detail: any) {
  //   this.enqDetail = detail;
  // }
  // getEnqDetail() {
  //   return this.enqDetail;
  // }
}
const PERCENT = 'PERCENT';
const FLAT = 'FLAT';
const FREE = 'FREE';

const KG = 'KG';
const PC = 'PC';
const L = 'L';
const AMT = 'AMT';

const BRAND = 'BRAND';
const ITEM = 'ITEM';
const CATEGORY = 'CATEGORY';
const SKU = 'SKU';
